import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from '../../shared/message.service';
import { TopicService } from '../topic.service';
import { GraphService } from '../../General/graph/graph.service';
import { GraphExerciseComponent } from '../../shared/interactive-graph/exercise_components/graph-exercise.component';
import { InteractiveGraph } from 'graph-interactive/dist/lib/interactive/interactiveGraph';
import { GraphUU } from '../../shared/interactive-graph/simple_graphs/graphUU';
import { InteractionType, Interactable } from 'graph-interactive';
import { AbstractEdge } from 'graph-interactive/dist/lib/abstract/aEdge';

@Component({
  selector: 'app-find-hamilton',
  templateUrl: './find-hamilton.component.html',
  styleUrls: ['./find-hamilton.component.css']
})
export class FindHamiltonComponent extends GraphExerciseComponent {

  private readonly canvasID: string = 'graph-canvas';
  private readonly resetPathID: string = 'resetPathButton';



  constructor(protected activatedRoute: ActivatedRoute, protected topicService: TopicService,
    protected messageService: MessageService, graphService: GraphService) {
    super(activatedRoute, topicService, messageService);
    this.printable = true;
    this.type = 'findHamilton';
  }

  initGraph(): InteractiveGraph {
    const canvas = <HTMLCanvasElement>document.getElementById(this.canvasID);
    const g = new HGraphUU(canvas);
    g.setInteractionType(InteractionType.HIGHLIGHT_SIMPLE_PATH);
    g.initSelected(false);

    const resetPathButton = <HTMLButtonElement>document.getElementById(this.resetPathID);
    resetPathButton.addEventListener('click', this.onResetPath, false);

    return g;
  }

  onResetPath = () => {
    this.resetPath();
  }

  resetPath() {
    this.graph.resetSelected();
    this.graph.initSelected(false);
    this.graph.forceUpdate();
  }



  checkSolution() {

    let result = this.evaluate();
    if (result[0] == result[1]) {
      this.messageService.addAlertWithTimeout(this.get('success'), 'success', 10000);
      this.solved = true;
      this.state.solved = true;
      this.saveState();
    } else {
      this.messageService.addAlertWithTimeout(this.get('NotFoundHamiltonPath'), 'danger', 10000);
    }

  }

  setTypeSpecificsFromState() {
    //TODO: Restore found hamilton path
    //No need to do that.
  }



  computeState() {
    //Nothing to store
  }

  resetState() {
    super.resetState();
    this.graph.initSelected(false);
    this.graph.resetSelected();
    this.graph.forceUpdate();
  }



  setTypeSpecificsFromConfiguration() {
  }

  evaluate(): [number, number] {
    let selectedNodes = this.graph.getSelectedNodes();
    let allNodes = this.graph.getGraph().getNodes();

    return [(selectedNodes.length == allNodes.length) ? 1 : 0, 1];
  }
}


//Specific graph for making edges non interactable
class HGraphUU extends GraphUU {
  disableHover(interactabe: Interactable): boolean {
    if (interactabe instanceof AbstractEdge) {
      return true;
    }
    return super.disableHover(interactabe);
  }
}
